import { forwardRef } from 'react';
import TextParser from '@/pages/Root/components/TextParser/TextParser';
import PublisherLogo from '../PublisherLogo/PublisherLogo';
import { StorySize } from '@/moment/types/story-types';
import './Card.scss';

interface CardProps {
  title?: string;
  summary?: string;
  isIgnoreParagraphInDescription?: boolean;
  publisherLogo?: string;
  publisherName?: string;
  darkPublisherLogo?: string;
  credit?: string;
  isDark?: boolean;
  caption?: string;
  onScroll?: (isScrolledDown: boolean) => void;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      title,
      summary,
      isIgnoreParagraphInDescription = false,
      publisherLogo,
      publisherName,
      darkPublisherLogo,
      isDark,
      caption,
      onScroll,
      credit,
    },
    ref
  ) => {
    return (
      <div
        className="card"
        data-testid="test-card"
        ref={ref}
        role="group"
        aria-label={title}
        onScroll={(event) => {
          if (onScroll) {
            onScroll(event.currentTarget.scrollTop !== 0);
          }
        }}
      >
        {publisherLogo ? (
          <PublisherLogo
            publisherLogo={publisherLogo ?? null}
            publisherName={publisherName ?? ''}
            darkPublisherLogo={darkPublisherLogo}
            isDark={isDark}
            storySize={StorySize.MEDIUM}
          />
        ) : (
          ''
        )}
        {title ? <h2 className="card-title title-lg" aria-hidden="true">{title}</h2> : ''}
        <div className="card-credit">{credit ?? ''}</div>
        {summary ? (
          <div className="card-summary body-md">
            <TextParser
              text={summary}
              option={{
                isIgnoreParagraph: isIgnoreParagraphInDescription,
                useJsx: true,
              }}
            />
          </div>
        ) : (
          ''
        )}
        {caption ? <div className="card-caption caption">{caption}</div> : ''}
      </div>
    );
  }
);

export default Card;
